import "./Payment.scss";
import Cards from "./components/Cards/Cards";
import Invoices from "./components/Invoices/Invoices";

const Payment = () => {
  return (
    <div className="account-content">
      <div
        className="payment"
        style={{
          background: "#171717",
          padding: 30,
          borderRadius: 7,
          maxWidth: 1000,
        }}
      >
        <Cards />
        <Invoices />
      </div>
    </div>
  );
};

export default Payment;
